// extracted by mini-css-extract-plugin
export default {"search":"Sidedrawer_search__BaFl0","drawercontainer":"Sidedrawer_drawercontainer__S4vhJ","nav-btn":"Sidedrawer_nav-btn__8QwDi","logoside":"Sidedrawer_logoside__DiNiq"};